import { render, staticRenderFns } from "./borui.vue?vue&type=template&id=ab2f3218&scoped=true"
import script from "./borui.vue?vue&type=script&lang=js"
export * from "./borui.vue?vue&type=script&lang=js"
import style0 from "./borui.vue?vue&type=style&index=0&id=ab2f3218&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2f3218",
  null
  
)

export default component.exports